import React from "react";
import "./../attendance.css";
import moment from "moment/moment";

const AttendanceModal = ({ show, onClose, attendance }) => {
  if (!show || !attendance) return null;

  const getStatus = () => {
    if (!attendance.checkInTime) {
      return {
        text: "Absent",
        className: "bg-danger",
      };
    }

    if (!attendance.checkOutTime) {
      return {
        text: "Working",
        className: "bg-info",
      };
    }

    return {
      text: "Present",
      className: "bg-success",
    };
  };

  const status = getStatus();

  return (
    <>
      <div
        className="modal fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            {/* Header */}

            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-person-badge-fill me-2"></i>
                Attendance Details
              </h5>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              >
                <i aria-hidden="true" className="ki ki-close" />
              </button>
            </div>

            {/* Body */}

            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <small className="text-muted">Employee ID</small>

                  <div className="fw-semibold">{attendance.employeeId}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <small className="text-muted">Name</small>

                  <div className="fw-semibold">{attendance.name}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <small className="text-muted">Designation</small>

                  <div>{attendance.designation}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <small className="text-muted">Mobile Number</small>

                  <div>{attendance.mobileNumber}</div>
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="attendance-info-card">
                    <i className="bi bi-person-check-fill text-success fs-2"></i>

                    <div className="mt-2 text-muted">Status</div>

                    <span className={`badge ${status.className}`}>
                      {status.text}
                    </span>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="attendance-info-card">
                    <i className="bi bi-box-arrow-in-right text-primary fs-2"></i>

                    <div className="mt-2 text-muted">Check In</div>

                    <div className="fw-bold">
                      {attendance?.checkInTime
                        ? moment
                            .utc(attendance.checkInTime)
                            .local()
                            .format("hh:mm A")
                        : "-"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="attendance-info-card">
                    <i className="bi bi-box-arrow-right text-danger fs-2"></i>

                    <div className="mt-2 text-muted">Check Out</div>

                    <div className="fw-bold">
                      {attendance?.checkOutTime
                        ? moment
                            .utc(attendance.checkOutTime)
                            .local()
                            .format("hh:mm A")
                        : "-"}
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="attendance-info-card">
                    <i className="bi bi-signpost-fill text-warning fs-2"></i>

                    <div className="mt-2 text-muted">Visits</div>

                    <div className="fw-bold fs-4">{attendance.visitCount}</div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="attendance-info-card">
                    <i className="bi bi-geo-alt-fill text-info fs-2"></i>

                    <div className="mt-2 text-muted">Distance</div>

                    <div className="fw-bold fs-4">
                      {attendance.distanceKm} km
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>

              <button className="btn btn-primary">
                <i className="bi bi-map me-2"></i>
                View Route
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AttendanceModal;
